// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import Typography from 'components/Typography/Typography';
import pxToEm from 'theme/pxToEm';

export const NoResultsWrapper = styled.div`
  padding: 1.875em;
  ${({ theme }) => theme.breakpoints.down('md')} {
    min-height: 24em;
    justifycontent: flex-start;
  }
  min-height: 36em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToEm(24)};
`;

export const TextBox = styled(Typography)`
  color: ${({ theme }) => theme.palette.grey.A400};
`;
